export default __webpack_public_path__ + "static/media/menu-down-black.fd5e7526.svg";